import React, { useCallback, useState } from 'react'
import Spacing from '../componenets/UI/Spacing'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import axiosClient from '../config/axios-client'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import FutureMineralCountriesCard from '../componenets/global/FutureMineralCountriesCard'
import { Helmet } from 'react-helmet'

export default function SearchPage() {
  const { t } = useTranslation()
  const { query, lng } = useParams()

  const [results, setResults] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const getFutureMinerals = useCallback(() => {
    window.scrollTo(0, 0)
    setIsLoading(true)
    axiosClient
      .get(`/platform/search/${query}`)
      .then(({ data }) => {
        setResults(data.results)
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false)
      })
  }, [query])

  useEffect(() => {
    getFutureMinerals()
  }, [getFutureMinerals])

  return (
    <div>
      <Helmet>
        <title>{`APFM | ${t('SEARCH_RESULTS')} : ${query}`}</title>
      </Helmet>
      <Spacing />
      <div className="app-container px-8 lg:px-0">
        <h2
          data-aos={`fade-down`}
          data-aos-delay={100}
          className="mb-8 text-2xl font-black"
        >
          {t('SEARCH_RESULTS')}
        </h2>
        <div className="mb-16">
          <h3 className="mb-4 text-xl font-bold">{t('MINERALS')}</h3>
          {isLoading ? (
            <div className="flex flex-col gap-4">
              {[...Array(3)].map((_, index) => (
                <div key={index}>
                  <div className="border-muted-300 flex animate-pulse border-2">
                    <div className="border-muted-300 ltr:border-r-2 rtl:border-l-2">
                      <div className="!h-32 !w-32 min-w-32 bg-light p-4" />
                    </div>
                    <div className="flex w-full flex-col p-4">
                      <div className="bg-muted-300 mb-4 h-7 w-32" />
                      <div className="bg-muted-300 mb-2 h-3 w-full" />
                      <div className="bg-muted-300 mb-2 h-3 w-full" />
                      <div className="bg-muted-300 h-3 w-1/2" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              {results?.minerals.map((mineral) => (
                <div
                  data-aos="fade-left"
                  data-aos-delay={200}
                  key={mineral.id}
                >
                  <Link
                    to={`/${lng}/future-minerals/${mineral.slug}`}
                    className="border-muted-300 flex transform cursor-pointer border-2 transition duration-300 ease-in-out hover:bg-light"
                  >
                    <div className="border-muted-300 ltr:border-r-2 rtl:border-l-2">
                      <img
                        className="!h-32 min-w-32 p-4"
                        src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals${mineral.image}`}
                        alt={mineral[`name_${lng}`]}
                      />
                    </div>
                    <div className="flex flex-col p-4">
                      <h3 className="flex text-xl font-bold capitalize">
                        {mineral[`name_${lng}`]} (<span className="text-secondary-600">{mineral.symbol}</span>)
                      </h3>
                      <div
                        className="line-clamp-3"
                        dangerouslySetInnerHTML={{ __html: mineral[`description_${lng}`] }}
                      />
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          <h3 className="mb-4 text-xl font-bold">{t('FUTURE_MINERALS_REGION')}</h3>
          {isLoading ? (
            <div className={`grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4`}>
              <div className={`border-muted-300 col-span-1 flex w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 bg-white`}>
                <div className="relative h-[218px] w-full">
                  <img
                    src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                    alt="background icon"
                    className="absolute -bottom-10 -right-10 w-36 opacity-25"
                  />
                  <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
                    <div className="absolute right-2 top-2">
                      <img
                        src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                        alt="icon"
                        className="w-8"
                      />
                    </div>
                    <div className="bg-muted-300 h-[100px] w-[100px]" />
                    <div className="flex flex-col items-center">
                      <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
                      <p className="bg-muted-300 h-[16px] w-6"></p>
                    </div>
                  </div>
                </div>
                <div className="bg-muted-300 z-10 flex w-full gap-2 overflow-hidden pb-1.5 pt-2 rtl:flex-row-reverse">
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                </div>
              </div>
              <div className={`border-muted-300 hidden w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 bg-white sm:col-span-1 sm:flex`}>
                <div className="relative h-[218px] w-full">
                  <img
                    src="/assets/icons/industrial-color/industrial-icon.svg"
                    alt="background icon"
                    className="absolute -bottom-10 -right-10 w-36 opacity-25"
                  />
                  <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
                    <div className="absolute right-2 top-2">
                      <img
                        src="/assets/icons/industrial-color/industrial-icon.svg"
                        alt="icon"
                        className="w-8"
                      />
                    </div>
                    <div className="bg-muted-300 h-[100px] w-[100px]" />
                    <div className="flex flex-col items-center">
                      <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
                      <p className="bg-muted-300 h-[16px] w-6"></p>
                    </div>
                  </div>
                </div>
                <div className="bg-muted-300 z-10 flex w-full gap-2 overflow-hidden pb-1.5 pt-2 rtl:flex-row-reverse">
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                </div>
              </div>
              <div className={`border-muted-300 hidden w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 bg-white md:col-span-1 md:flex`}>
                <div className="relative h-[218px] w-full">
                  <img
                    src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                    alt="background icon"
                    className="absolute -bottom-10 -right-10 w-36 opacity-25"
                  />
                  <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
                    <div className="absolute right-2 top-2">
                      <img
                        src="/assets/icons/clean-energy-color/clean-energy-icon.svg"
                        alt="icon"
                        className="w-8"
                      />
                    </div>
                    <div className="bg-muted-300 h-[100px] w-[100px]" />
                    <div className="flex flex-col items-center">
                      <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
                      <p className="bg-muted-300 h-[16px] w-6"></p>
                    </div>
                  </div>
                </div>
                <div className="bg-muted-300 z-10 flex w-full gap-2 overflow-hidden pb-1.5 pt-2 rtl:flex-row-reverse">
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                </div>
              </div>
              <div className={`border-muted-300 hidden w-full animate-pulse flex-col items-center justify-center space-y-1 overflow-hidden border-2 bg-white lg:col-span-1 lg:flex`}>
                <div className="relative h-[218px] w-full">
                  <img
                    src="/assets/icons/industrial-color/industrial-icon.svg"
                    alt="background icon"
                    className="absolute -bottom-10 -right-10 w-36 opacity-25"
                  />
                  <div className="relative z-10 flex flex-col items-center gap-4 p-4 pt-10">
                    <div className="absolute right-2 top-2">
                      <img
                        src="/assets/icons/industrial-color/industrial-icon.svg"
                        alt="icon"
                        className="w-8"
                      />
                    </div>
                    <div className="bg-muted-300 h-[100px] w-[100px]" />
                    <div className="flex flex-col items-center">
                      <p className="bg-muted-300 mb-2 h-[16px] w-20"></p>
                      <p className="bg-muted-300 h-[16px] w-6"></p>
                    </div>
                  </div>
                </div>
                <div className="bg-muted-300 z-10 flex w-full gap-2 overflow-hidden pb-1.5 pt-2 rtl:flex-row-reverse">
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                  <div className="h-8 min-w-14 bg-white"></div>
                </div>
              </div>
            </div>
          ) : (
            <div
              data-aos={`fade-up`}
              data-aos-delay={100}
              className="grid grid-cols-12 gap-4"
            >
              {results?.minerals_region.map(
                (mineral) =>
                  mineral.countries.length != 0 && (
                    <FutureMineralCountriesCard
                      isGridChild={true}
                      mineral={mineral}
                      link={`/${lng}/future-minerals/region/${mineral.slug}${mineral.slug == 'altylyryom-tellurium' ? '?country=22' : ''}`}
                      key={mineral.id}
                      lng={lng}
                      isMarqueeSlider={false}
                    />
                  ),
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
